import { createContext, Dispatch, ReactChildren, ReactNode, SetStateAction, useState } from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
interface DrawerContextType<A = any> {
  active: boolean;
  setActive: Dispatch<SetStateAction<boolean>>;
  drawerType: 'Drawer';
  setDrawerType: Dispatch<SetStateAction<DrawerContextType<A>['drawerType']>>;
  drawerProps?: A;
  setDrawerProps: Dispatch<SetStateAction<A>>;
  setDrawer: <P extends A>(p: { type: DrawerContextType<A>['drawerType']; props: P }) => void;
  children: ReactChildren | ReactChildren[] | ReactNode[] | ReactNode;
}

export const DrawerContext = createContext<
  Pick<DrawerContextType, 'setDrawer' | 'active' | 'setActive' | 'drawerType' | 'drawerProps'>
>({
  setDrawer: function (): void {},
  setActive: function (): void {},
  active: false,
  drawerType: 'Drawer',
});

export const DrawerProvider = <A extends unknown>({ children }: Partial<DrawerContextType<A>>): JSX.Element => {
  const [active, setActive] = useState<boolean>(false);
  const [drawerType, setDrawerType] = useState<DrawerContextType<A>['drawerType']>('Drawer');
  const [drawerProps, setDrawerProps] = useState<unknown>();
  const setDrawer: (p: { type: DrawerContextType<A>['drawerType']; props: unknown }) => void = ({ type, props }) => {
    setDrawerType(type);
    setDrawerProps(props);
    setActive(true);
  };

  return (
    <DrawerContext.Provider value={{ setActive, active, setDrawer, drawerType, drawerProps }}>
      <>{children}</>
    </DrawerContext.Provider>
  );
};
